import React from 'react';
import {wrapGenericChannel} from '../genericChannel.react';
import {ChannelView} from '../genericChannel.react';
import {FormattedMessage, IntlShape} from 'react-intl';
import {ROSSUM_DOMAIN} from '../../../common/constants/Rossum';

import './rossumChannelView.scss';

class RossumChannelView extends ChannelView {

	renderContent() {
		const channel = this.props.user.organisation.channel;
		let options = JSON.parse(channel.options);

		if (!options.username) {
			// this is stand-alone rossum application
			// there is Relevant scenarios strip managed by @parent ChannelView (for published scenarios)
			return (null);
		}

		return (
			<table className="RossumChannelViewTable">
				{options.inboxEmail ? <tr>
					<th><FormattedMessage defaultMessage="Email for invoices:" id="rossumChannelView.email" /></th>
					<td><a href={"mailto:" + options.inboxEmail}>{options.inboxEmail}</a>/</td>
				</tr> : null}
				<tr>
					<th><FormattedMessage defaultMessage="Server:" id="rossumChannelView.server" /></th>
					<td><a href={"https://" + ROSSUM_DOMAIN + "/"} target="_blank">https://{ROSSUM_DOMAIN}/</a></td>
				</tr>
				<tr>
					<th><FormattedMessage defaultMessage="Username:" id="rossumChannelView.username" /></th>
					<td>{options.username}</td>
				</tr>
			</table>
		);
	}
}

export default wrapGenericChannel(RossumChannelView);
